import React from 'react'

import { RoundedButtonBlock } from 'Blocks'
import { RouterLinkTemplate, LazyYouTubeEmbed } from 'Components'
import { addWebPToImageURL } from 'Helpers/utilities'

const BankAnywhereBlock = ({ data, inEditMode }) => {
  const { Heading, Subheading, Button, VideoLink, AppStoreImage, AppStoreUrl, GooglePlayImage, GooglePlayUrl } = data

  const UrlContainer = () => {
    return (
      <div className="md:flex grid grid-cols-2 gap-3 md:my-16 my-8">
        <RouterLinkTemplate Path={AppStoreUrl} inEditMode={inEditMode}>
          {(AppStoreImage || inEditMode) && (
            <span data-epi-edit="AppStoreImage">
              <img className="lazy w-full md:w-auto h-12 hover:opacity-90 cursor-pointer" data-src={addWebPToImageURL(AppStoreImage?.Url)} alt={AppStoreImage?.AltTag}/>
              {inEditMode && !AppStoreImage && 'Click to edit Image'}
            </span>
          )}
          {inEditMode && <div data-epi-edit="AppStoreUrl" className="mt-2 text-sm text-gray-500">Click to edit Url</div>}
        </RouterLinkTemplate>
        <RouterLinkTemplate Path={GooglePlayUrl} inEditMode={inEditMode}>
          {(GooglePlayImage || inEditMode) && (
            <span data-epi-edit="GooglePlayImage">
              <img className="lazy w-full md:w-auto h-12 hover:opacity-90 cursor-pointer" data-src={addWebPToImageURL(GooglePlayImage?.Url)} alt={GooglePlayImage?.AltTag}/>
              {inEditMode && !GooglePlayImage && 'Click to edit Image'}
            </span>
          )}
          {inEditMode && <div data-epi-edit="GooglePlayUrl" className="mt-2 text-sm text-gray-500">Click to edit Url</div>}
        </RouterLinkTemplate>
      </div>
    )
  }

  return (
    <div className="container mx-auto max-w-screen-xl">
      <div className="xl:mx-32 lg:mx-28 md:mx-12 sm:mx-8 mx-6 lg:py-10 md:py-7 py-4">
        <div className="sm:grid sm:grid-cols-2 sm:items-center">
          <div className="grid sm:px-10">
            <h2 className="mx-6 text-lg font-medium font-display tracking-tighter sm:mx-0 sm:text-2xl lg:text-4xl">
              <span data-epi-edit="Heading">
                {Heading}
                {inEditMode && !Heading && 'Click to edit Heading'}
              </span>
            </h2>
            {Subheading && (
              <h3 className="mx-6 mt-3 text-sm font-medium font-display tracking-tight sm:mx-0 sm:mt-0 sm:mb-6 sm:text-xl lg:mt-6 lg:mb-12 lg:text-2xl">
                <span data-epi-edit="Subheading">
                  {Subheading}
                  {inEditMode && !Subheading && 'Click to edit Subheading'}
                </span>
              </h3>
            )}
            <div className="sm:hidden my-6" data-epi-edit="VideoLink">
              <LazyYouTubeEmbed videoUrl={VideoLink} inEditMode={inEditMode} />
            </div>
            <div className="hidden sm:block">
              <RoundedButtonBlock data={Button} name='Button' inEditMode={inEditMode} />
            </div>
            <div className="sm:hidden justify-self-center">
              <RoundedButtonBlock data={Button} name='Button' inEditMode={inEditMode}
                overrideClass='focus:outline-none rounded-full md:font-display font-body font-medium md:text-lg text-sm
              border-2 border-violet hover:border-violet-dark text-violet hover:text-violet-dark
              md:py-2 py-1 px-6'/>
            </div>
            <UrlContainer />
          </div>
          <div className="hidden sm:block" data-epi-edit="VideoLink">
            <LazyYouTubeEmbed videoUrl={VideoLink} inEditMode={inEditMode} />
          </div>
        </div>
      </div>
    </div>
  )
}

export default React.memo(BankAnywhereBlock)
